export default __webpack_public_path__ + "static/media/RecentUploads.9e05be24.svg";